export class Direction{
    public static up:number = 1;
    public static down:number = 2;
}